module.exports = __webpack_public_path__ + "img/avatar-s-18.0ffcd7b4.jpg";